/**
 * 配置编译环境和线上环境之间的切换
 *
 * env: 域名地址
 */

const environment = ['test-', 'localhost']
const env = environment.some((cur) => {
  return location.host.includes(cur)
}) ? require('./.env.test') : require('./.env.production')

export default env.default